/**
 * Start Center API — персональная готовность сотрудника к работе.
 *
 * Только чтение: фото, реквизиты и внешние логины пишутся своими существующими
 * эндпоинтами, а центр показывает состояние. `API_BASE` уже содержит
 * `/api/v1`, поэтому путь идёт без префикса.
 */

import { apiFetch } from './core'

export const startCenter = {
    /** Свой центр. Идентификатор сотрудника не передаётся — скоуп считает сервер. */
    me: () => apiFetch('/start-center/me'),
    /** Готовность конкретного сотрудника — для HR, руководителя и IT. */
    forEmployee: (employeeId) => apiFetch(`/start-center/${employeeId}`),
    /** Ответ на пульс старта — всегда за себя, идентификатор не передаётся. */
    answerPulse: (answer, comment) => apiFetch('/start-center/pulse', {
        method: 'POST',
        body: JSON.stringify({ answer, comment: comment || null }),
    }),
}
